import type { IconProps } from './../../models/icon';

export function StorefrontIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <defs>
        <path
          id="reuse-0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1425 6.85718V8.56752C23.1425 9.47474 22.7822 10.3448 22.1405 10.9863C21.499 11.6278 20.629 11.9882 19.7218 11.9882H19.2943C18.3869 11.9882 17.5169 11.6278 16.8754 10.9863C16.2339 10.3448 15.8735 9.47474 15.8735 8.56752V6.85718"
        />
        <path
          id="reuse-1"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M15.8738 6.85718V8.56752C15.8738 9.47474 15.5134 10.3448 14.8719 10.9863C14.2304 11.6278 13.3603 11.9882 12.4531 11.9882H11.5979C10.6907 11.9882 9.82065 11.6278 9.17914 10.9863C8.53764 10.3448 8.17725 9.47474 8.17725 8.56752V6.85718"
        />
        <path
          id="reuse-2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M8.17719 6.85718V8.56752C8.17719 9.47474 7.8168 10.3448 7.17529 10.9863C6.53379 11.6278 5.66372 11.9882 4.7565 11.9882H4.27762C3.37038 11.9882 2.50033 11.6278 1.85883 10.9863C1.21733 10.3448 0.856934 9.47474 0.856934 8.56752V6.85718"
        />
      </defs>
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M2.57129 14.5715V22.2858C2.57129 22.5131 2.6616 22.7312 2.82235 22.892C2.98308 23.0526 3.2011 23.143 3.42843 23.143H20.5713C20.7986 23.143 21.0167 23.0526 21.1775 22.892C21.3381 22.7312 21.4284 22.5131 21.4284 22.2858V14.5715"
        />
        <path
          fill={secondaryColor}
          d="M23.1425 6.85718V8.56752C23.1425 9.47474 22.7822 10.3448 22.1405 10.9863C21.499 11.6278 20.629 11.9882 19.7218 11.9882H19.2943C18.3869 11.9882 17.5169 11.6278 16.8754 10.9863C16.2339 10.3448 15.8735 9.47474 15.8735 8.56752V6.85718"
        />
        <use
          xlinkHref="#reuse-0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <path
          fill={secondaryColor}
          d="M15.8738 6.85718V8.56752C15.8738 9.47474 15.5134 10.3448 14.8719 10.9863C14.2304 11.6278 13.3603 11.9882 12.4531 11.9882H11.5979C10.6907 11.9882 9.82065 11.6278 9.17914 10.9863C8.53764 10.3448 8.17725 9.47474 8.17725 8.56752V6.85718"
        />
        <use
          xlinkHref="#reuse-1"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <path
          fill={secondaryColor}
          d="M8.17719 6.85718V8.56752C8.17719 9.47474 7.8168 10.3448 7.17529 10.9863C6.53379 11.6278 5.66372 11.9882 4.7565 11.9882H4.27762C3.37038 11.9882 2.50033 11.6278 1.85883 10.9863C1.21733 10.3448 0.856934 9.47474 0.856934 8.56752V6.85718"
        />
        <use
          xlinkHref="#reuse-2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <path
          fill={secondaryColor}
          d="M2.57129 17.1428H13.7141V23.1428H2.57129V17.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M2.57129 14.5715V22.2858C2.57129 22.5131 2.6616 22.7312 2.82235 22.892C2.98308 23.0526 3.2011 23.143 3.42843 23.143H20.5713C20.7986 23.143 21.0167 23.0526 21.1775 22.892C21.3381 22.7312 21.4284 22.5131 21.4284 22.2858V14.5715"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M13.7144 14.5715V23.143"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M2.57129 17.1428H13.7141"
        />
        <path
          fill={secondaryColor}
          d="M0.856934 6.85718L3.42836 0.857178H20.5712L23.1426 6.85718H0.856934Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 6.85718L3.42836 0.857178H20.5712L23.1426 6.85718H0.856934Z"
        />
        <use
          xlinkHref="#reuse-2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <use
          xlinkHref="#reuse-1"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <use
          xlinkHref="#reuse-0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
      </g>
    </svg>
  );
}
